export const styles = ({ typography, palette }) => ({
  tooltip: {
    fontSize: typography.caption.fontSize,
    background: palette.surface.tooltip,
    color: palette.text.inverse,
  },
});
